// localStorage, not sessionStorage: the magic link and the SSO round trip can land in another tab.
const STORAGE_KEY = 'formshive-post-login-path';

const ACCOUNT_PATH = /^\/(?:[a-z]{2}\/)?account(?:[/?]|$)/;

/** Only in-app account paths qualify, so `next` cannot send anyone elsewhere. */
export function isSafePostLoginPath(path: string | null | undefined): path is string {
  return !!path && path.startsWith('/') && !path.startsWith('//') && ACCOUNT_PATH.test(path);
}

/** Stores `next` from the sign-in URL; anything else clears a stale value. */
export function rememberPostLoginPath(path: string | null | undefined): void {
  try {
    if (isSafePostLoginPath(path)) {
      localStorage.setItem(STORAGE_KEY, path);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // storage unavailable: sign-in falls back to the account home
  }
}

/** On sign-out, so a path stored by one account never applies to the next. */
export function clearPostLoginPath(): void {
  rememberPostLoginPath(null);
}

export function takePostLoginPath(): string | null {
  try {
    const path = localStorage.getItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_KEY);
    return isSafePostLoginPath(path) ? path : null;
  } catch {
    return null;
  }
}
